import { CloseButton } from "@/components/Search/SearchBar/components/SearchBox/components/closeButton";
import { Form } from "@/components/Search/SearchBar/components/SearchBox/components/form";
import { Input } from "@/components/Search/SearchBar/components/SearchBox/components/input";
import { OpenButton } from "@/components/Search/SearchBar/components/SearchBox/components/openButton";
import { ResetButton } from "@/components/Search/SearchBar/components/SearchBox/components/resetButton";
import { SubmitButton } from "@/components/Search/SearchBar/components/SearchBox/components/submitButton";
import { Base } from "@/components/Search/SearchBar/components/SearchBox/searchBox.base";

export const SearchBox = Object.assign(Base, {
    CloseButton: CloseButton,
    Form: Object.assign(Form, {
        Input: Input,
        OpenButton: OpenButton,
        ResetButton: ResetButton,
        SubmitButton: SubmitButton
    })
});
